import { ApiService } from '@DavisDigital/davisdigitalfrontend.module';

type FormContents = {
    formCode: string;
    formFields: any;
}

export class FormService {
	//@ngInject
	constructor( 
		private $http      : ng.IHttpService,
		private $q         : ng.IQService,
		private apiService : ApiService
	) {}
	
	public submitForm = ( formCode: string, formFields: any ) : ng.IPromise<any> => {
		let deferred = this.$q.defer<any>();
		
		let data: FormContents = { formCode, formFields };
		
		this.apiService.request( 'davisdigital:api.submitForm', data ).then( result => {
			deferred.resolve( result.data );
		}).catch( result => {
			deferred.reject( result );
		});
		
		return deferred.promise;
	}
}